export const SENTRY_ENABLED_ENVS = ['qa', 'production', 'dev', 'sandbox'];
export const NON_PROD_SENTRY_ENABLED_ENVS = ['qa', 'dev', 'sandbox', 'local'];
